/*
 * ceq-newsletter-band.js
 * Submit-Handler fuer sections/ceq-newsletter-band.liquid (Newsletter-Band ueber dem Footer).
 *
 * Features (analog ceq-lead-form.js):
 * - Honeypot-Check: ausgefuelltes "website"-Feld => verworfen (fake success)
 * - Time-Trap: Submit muss mind. MIN_FILL_TIME_MS nach Pageload erfolgen
 * - E-Mail-Validierung clientseitig (leer vs. ungueltig, Inline-Fehler, role=alert)
 * - Hidden-Fields (page_url, referrer, form_loaded_at) werden befuellt
 * - Fetch-POST an action-URL (n8n-Webhook) mit Loading/Success/Error-States
 * - GA4 dataLayer-Event "newsletter_signup" bei echtem Erfolg
 *
 * Greift NUR bei Formularen mit data-ceq-nlband-ajax="true" (= webhook_url gesetzt).
 * Ohne Webhook bleibt der native Submit aktiv (Fallback-Navigation auf Danke-Seite).
 * Geladen via <script defer>.
 */
(function () {
  'use strict';

  var MIN_FILL_TIME_MS = 2000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init() {
    var forms = document.querySelectorAll('[data-ceq-nlband-form][data-ceq-nlband-ajax="true"]');
    if (!forms.length) return;
    forms.forEach(setupForm);
  }

  function setupForm(form) {
    if (form.dataset.ceqNlbandReady === '1') return;
    form.dataset.ceqNlbandReady = '1';

    var loadedAt = Date.now();
    prefillHiddenFields(form);

    var input = form.querySelector('input[name="email"]');
    if (input) {
      input.addEventListener('input', function () {
        if (input.classList.contains('is-error')) {
          input.classList.remove('is-error');
          hideError(form);
        }
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      // Bot-Verdacht: Honeypot oder zu schnell => still verwerfen, fake success
      if (isHoneypotFilled(form) || Date.now() - loadedAt < MIN_FILL_TIME_MS) {
        showSuccess(form);
        return;
      }

      var email = input ? input.value.trim() : '';
      if (!email) {
        showFieldError(form, input, form.getAttribute('data-msg-empty'));
        return;
      }
      if (!EMAIL_RE.test(email)) {
        showFieldError(form, input, form.getAttribute('data-msg-invalid'));
        return;
      }

      submitForm(form);
    });
  }

  function isHoneypotFilled(form) {
    var hp = form.querySelector('input[name="website"]');
    return hp && hp.value.trim() !== '';
  }

  function prefillHiddenFields(form) {
    var pageUrl = form.querySelector('input[name="page_url"]');
    if (pageUrl) pageUrl.value = window.location.href;

    var referrer = form.querySelector('input[name="referrer"]');
    if (referrer) referrer.value = document.referrer || '';

    var loadedAtInput = form.querySelector('input[name="form_loaded_at"]');
    if (loadedAtInput) loadedAtInput.value = Date.now();
  }

  function showFieldError(form, input, message) {
    if (input) {
      input.classList.add('is-error');
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }
    var errorBox = form.querySelector('[data-ceq-nlband-error]');
    if (errorBox) {
      errorBox.textContent = message || '';
      errorBox.hidden = false;
    }
  }

  function hideError(form) {
    var errorBox = form.querySelector('[data-ceq-nlband-error]');
    if (errorBox) errorBox.hidden = true;
    var input = form.querySelector('input[name="email"]');
    if (input) input.removeAttribute('aria-invalid');
  }

  function submitForm(form) {
    var submitBtn = form.querySelector('[data-ceq-nlband-submit]');
    var input = form.querySelector('input[name="email"]');
    var label = form.querySelector('.ceq-nlband__button-label');
    var loadingLabel = form.querySelector('.ceq-nlband__button-loading');

    hideError(form);

    // FormData VOR dem Deaktivieren bauen: disabled-Felder werden laut HTML-Spec
    // nicht in FormData aufgenommen - sonst fehlt die E-Mail im POST an n8n.
    var action = form.getAttribute('action') || '';
    var formData = new FormData(form);

    if (submitBtn) submitBtn.disabled = true;
    if (input) input.disabled = true;
    if (label) label.hidden = true;
    if (loadingLabel) loadingLabel.hidden = false;

    fetch(action, { method: 'POST', body: formData, mode: 'cors' })
      .then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        showSuccess(form);
        trackSignup(form);
      })
      .catch(function (err) {
        console.error('[ceq-nlband] submit failed', err);
        showFieldError(form, input, form.getAttribute('data-msg-invalid'));
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
        if (input) input.disabled = false;
        if (label) label.hidden = false;
        if (loadingLabel) loadingLabel.hidden = true;
      });
  }

  function showSuccess(form) {
    form.hidden = true;
    var wrap = form.parentElement;
    var successBox = wrap ? wrap.querySelector('[data-ceq-nlband-success]') : null;
    if (successBox) successBox.hidden = false;
  }

  function trackSignup(form) {
    if (typeof window.dataLayer === 'undefined') return;
    window.dataLayer.push({
      event: 'newsletter_signup',
      form_id: form.getAttribute('data-section-id') || 'ceq-newsletter-band',
      page_path: window.location.pathname,
    });
  }

  /*
   * Kein Eingriff mehr in fremde Sections: Der weisse Abstand oberhalb des Bands kommt
   * als natuerlicher Bodenabstand ("Schluss") der vorherigen Section. Frueher hat das Band
   * diesen Abstand weggenullt (zur Balken-Symmetrie) - ohne weissen Rahmen fuehrte das zu
   * "zusammengedrueckten" Seiten (Frontpage, A-Line-Blog). Das Band steht jetzt buendig
   * am Footer, oben mit dem normalen Abstand des Vorgaengers.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
